export default function EditIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="edit-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 15}
      height={height ? height : width ? width : 15}
      viewBox="0 0 48 48"
    >
      <g
        transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <line x1="0.5" y1="13.5" x2="11.5" y2="13.5"></line>
        <path d="M6.5,10l-3,.54L4,7.5,10.73.79a1,1,0,0,1,1.42,0l1.06,1.06a1,1,0,0,1,0,1.42Z"></path>
      </g>
    </svg>
  );
}
